// The product name and logo in the top bar: the tenant's, from its branding (D-32, E12-S1-T4), or the
// default's — the name from the catalogue and the Waypoint mark the mockups draw in the Container
// title bar (mockups/container.js, icon "waypoint"). A tenant's logo is an inline image from its
// branding record, drawn at the mark's size; the name beside it says what it is, so it has no alt.
import { t } from "../i18n/t.js";
import { useTenantTheme } from "../theme/theme-gate.js";

function WaypointMark({ size = 18 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      aria-hidden
    >
      <circle cx={12} cy={12} r={8} />
      <circle cx={12} cy={12} r={2.8} fill="currentColor" stroke="none" />
    </svg>
  );
}

export function Brand() {
  const theme = useTenantTheme();
  return (
    <span className="flex items-center gap-2 whitespace-nowrap">
      <span className="grid text-wp-accent">
        {theme.logoRef === undefined ? (
          <WaypointMark />
        ) : (
          <img src={theme.logoRef} alt="" width={18} height={18} />
        )}
      </span>
      <span className="text-14 font-bold tracking-wide">
        {theme.productName ?? t("app.productName")}
      </span>
    </span>
  );
}
